import Decimal from 'decimal.js';

export function calculatePenalty(original, penaltyRate) {
  // use decimal.js to avoid floating point precision issues
  const dorg = new Decimal(original ?? 0);
  const drate = new Decimal(penaltyRate ?? 0);
  const result = dorg.times(drate).floor().toNumber();
  return result;
}
